// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3YJ2f","calendarButtons":"ClockData_calendarButtons__2fsPm"};